<template>
  <div class="my-post">
    <nav-bar :title="TagLabel" />
    <article-list :params="params" :url="url" />
  </div>
</template>
<script>
  import ArticleList from '@/components/ArticleList'
  import NavBar from '@/components/NavBar'
  import { useRoute } from 'vue-router'
  import { onActivated, onMounted, ref } from 'vue'
  import { wxShare } from '@/utils'
  import store from '@/store'
  export default {
    components: {
      ArticleList,
      NavBar,
    },
    setup() {
      const route = useRoute()
      let TagLabel = ref('')
      let TopicId = ref('')
      const url = 'case/PostSelectByTopic'
      let params = ref(null)
      onActivated(() => {
        setTimeout(() => {
          init()
        })
      })
      const init = () => {
        let newTopicId = route.query.TagId
        if (TopicId.value === newTopicId) return
        TopicId.value = newTopicId
        params.value = { TopicId: TopicId.value }
        TagLabel.value = route.query.TagLabel
      }
      onMounted(() => {
        const getCaseName = store.getters['user/getCaseName']
        wxShare(getCaseName, `【${route.query.TagLabel}】案例合集`)
      })
      return {
        url,
        TagLabel,
        params,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .my-post {
    padding: 44px 0 20px;
  }
</style>
